/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Feedback_Message_AriaInputs */

const en_feedback_message_aria = /** @type {(inputs: Feedback_Message_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What data are you missing?`)
};

const zh_hans1_feedback_message_aria = /** @type {(inputs: Feedback_Message_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你缺少哪些数据？`)
};

const pt_br2_feedback_message_aria = /** @type {(inputs: Feedback_Message_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que dados estão faltando?`)
};

const es_feedback_message_aria = /** @type {(inputs: Feedback_Message_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué datos te faltan?`)
};

const fr_feedback_message_aria = /** @type {(inputs: Feedback_Message_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quelles données vous manquent ?`)
};

const de_feedback_message_aria = /** @type {(inputs: Feedback_Message_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welche Daten fehlen dir?`)
};

const ru_feedback_message_aria = /** @type {(inputs: Feedback_Message_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Каких данных вам не хватает?`)
};

const it_feedback_message_aria = /** @type {(inputs: Feedback_Message_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quali dati ti mancano?`)
};

/**
* | output |
* | --- |
* | "What data are you missing?" |
*
* @param {Feedback_Message_AriaInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const feedback_message_aria = /** @type {((inputs?: Feedback_Message_AriaInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feedback_Message_AriaInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_feedback_message_aria(inputs)
	if (locale === "pt-BR") return pt_br2_feedback_message_aria(inputs)
	if (locale === "es") return es_feedback_message_aria(inputs)
	if (locale === "fr") return fr_feedback_message_aria(inputs)
	if (locale === "de") return de_feedback_message_aria(inputs)
	if (locale === "ru") return ru_feedback_message_aria(inputs)
	if (locale === "it") return it_feedback_message_aria(inputs)
	return en_feedback_message_aria(inputs)
});